import { render, staticRenderFns } from "./index.vue?vue&type=template&id=46a1fead&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a1fead",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46a1fead')) {
      api.createRecord('46a1fead', component.options)
    } else {
      api.reload('46a1fead', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=46a1fead&scoped=true", function () {
      api.rerender('46a1fead', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wellManage/approveWells/index.vue"
export default component.exports